import { API_URL } from 'constants';

export const GET_EMPLOYEES_SUMMARY = `${API_URL}/api/v1/employeedashboard/summary`;
export const GET_EMPLOYEE_ABSENCES = `${API_URL}/api/v1/employeedashboard`;
